module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8q1NL"))).then(() => parcelRequire('d0iPb'));